import { useCallback, useEffect, useRef } from 'react';

import { setCSSVariable } from './sticky-header';

export const useStickyHeaderElements = (
  stickyElementsHeight: string,
  elementForClassName?: React.MutableRefObject<HTMLDivElement | null>,
  disabled = false,
) => {
  const lastScrollTop = useRef(0);
  const showHeader = useRef(false);

  const scrollListener = useCallback(() => {
    const currentScrollTop =
      window.scrollY || document.documentElement.scrollTop;
    if (!disabled) {
      if (
        currentScrollTop > lastScrollTop.current && // scroll down
        showHeader.current
      ) {
        setCSSVariable(
          '--header-sticky-position',
          `calc(-1 * ${stickyElementsHeight})`,
        );
        if (elementForClassName?.current) {
          elementForClassName.current.classList.remove('sticky');
        }
        showHeader.current = false;
      } else if (
        currentScrollTop < lastScrollTop.current && // scroll up
        !showHeader.current
      ) {
        setCSSVariable('--header-sticky-position', '0px');
        if (elementForClassName?.current) {
          elementForClassName.current.classList.add('sticky');
        }
        showHeader.current = true;
      }
      // remember actual scroll position
      lastScrollTop.current = currentScrollTop <= 0 ? 0 : currentScrollTop; // For mobile or negative scrolling
    }
  }, [stickyElementsHeight, disabled, elementForClassName]);

  useEffect(() => {
    window.addEventListener('scroll', scrollListener);
    return () => {
      window.removeEventListener('scroll', scrollListener);
    };
  }, [scrollListener]);

  useEffect(() => {
    if (!disabled) {
      setCSSVariable(
        '--header-sticky-position',
        `calc(calc(-1 * ${stickyElementsHeight})`,
      );
    }
  }, [stickyElementsHeight, disabled]);
};
